/**
 * @fileoverview DELETE handler for the "/integrations/direct/cdi/sources/:source_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiSourcesSourceIdCacheKeys } from "./constants";
import type { DeleteIntegrationsDirectCdiSourcesSourceIdProps } from "./types";

export const deleteCdiSourcesConfig = reactQueryMutationAdapter(
  integrationsDirectCdiSourcesSourceIdCacheKeys,
  (props: DeleteIntegrationsDirectCdiSourcesSourceIdProps): Promise<null> => {
    return fetch(`/integrations/direct/cdi/sources/${props.sourceId}`, "DELETE", undefined, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
